import "../css/main.css";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Header from "../components/Header";
import GenericModal from "../components/GenericModal";
import MonthsList from "./components/MonthsList";
import useSchedule from "./useSchedule";
import CalendarFrame from "./components/CalendarFrame";
import SecondFrame from "./components/SecondFrame";
import MainFrame from "../components/MainFrame";
import ScheduleInfo from "./components/ScheduleInfo";

export default function Schedule({
  width,
  iconColor,
  openMainMsg,
  openMap,
  login,
  maps,
  users,
}) {
  const {
    currentDate,
    setOpen,
    reloadCalendar,
    handleScroll,
    handlers,
    dm,
    writeEachDay,
    secondBox,
    secondFlex,
    currentAct,
    askActivity,
    askEdit,
    msgType,
    open,
    closeMsg,
    startWritingCalendar,
    openWarningMsg,
    selectedTer,
  } = useSchedule({ openMainMsg, openMap, login, maps, users });

  return (
    <MainFrame width={width}>
      <Header
        MainIcon={CalendarMonthIcon}
        input={true}
        color={iconColor}
        type={"year-month"}
        searchStyle={{ width: "auto", minWidth: 120, textAlign: "center" }}
        value={currentDate}
        onClick={() => setOpen("monthsList")}
        refresh={reloadCalendar}
      />
      <div
        style={{
          position: "relative",
          flex: 1,
          backgroundColor: "red",
          overflow: "hidden",
        }}
      >
        <CalendarFrame
          handleScroll={handleScroll}
          handlers={handlers}
          secondFlex={secondFlex}
          dm={dm}
          writeEachDay={writeEachDay}
        />
        <SecondFrame
          currentAct={currentAct}
          askEdit={askEdit}
          secondBox={secondBox}
          secondFlex={secondFlex}
          askActivity={askActivity}
          openWarningMsg={openWarningMsg}
        />
      </div>
      <GenericModal open={open} data={msgType[open]} close={closeMsg}>
        {open === "monthsList" && (
          <MonthsList
            currentDate={currentDate}
            startWritingCalendar={startWritingCalendar}
            closeMsg={closeMsg}
          />
        )}
        {open === "openSchedule" && <ScheduleInfo info={selectedTer.info} />}
      </GenericModal>
    </MainFrame>
  );
}
